import Service from '@ember/service';
import { accounting } from 'accounting';

export default class FormatAmountService extends Service {
  // options
  // - roundToDollar
  //   - always round to the nearest dollar
  //   - default is false
  // - removeNoCents
  //   - If there are no cents, then remove them
  //   - default is false
  format(
    val: number | string,
    options: { roundToDollar?: boolean; removeNoCents?: boolean } = {},
  ) {
    let opts = Object.assign(
      { roundToDollar: false, removeNoCents: false },
      options,
    );
    let precision = opts.roundToDollar ? 0 : 2;
    let formatVal = accounting.formatMoney(val, { precision: precision });
    return opts.removeNoCents ? formatVal.replace(/\.00$/, '') : formatVal;
  }
}
